// index.js (entry point of the app)
import React from 'react';
import ReactDOM from 'react-dom/client';
import Root from './Root';  // Import Root component


const root = ReactDOM.createRoot(document.getElementById('root'));

//serviceWorker.register();

root.render(<Root />);